(function () {
  function updateContainer(container) {
    var checkbox = container.querySelector('.policy-cart-acknowledgement__checkbox');
    if (!checkbox) return;

    var formId = checkbox.getAttribute('form');
    var buttonSelector = formId === 'CartDrawer-Form' ? '#CartDrawer-Checkout' : '#checkout';
    var button = document.querySelector(buttonSelector);
    if (!button) return;

    button.disabled = !checkbox.checked;
    button.setAttribute('aria-disabled', checkbox.checked ? 'false' : 'true');
  }

  function updateAll() {
    document.querySelectorAll('[data-policy-acknowledgement]').forEach(updateContainer);
  }

  document.addEventListener('change', function (event) {
    if (!event.target.matches('.policy-cart-acknowledgement__checkbox')) return;
    var container = event.target.closest('[data-policy-acknowledgement]');
    if (container) updateContainer(container);
  });

  document.addEventListener('click', function (event) {
    var button = event.target.closest('#checkout, #CartDrawer-Checkout');
    if (!button) return;

    var formId = button.id === 'CartDrawer-Checkout' ? 'CartDrawer-Form' : 'cart';
    var checkbox = document.querySelector('.policy-cart-acknowledgement__checkbox[form="' + formId + '"]');
    if (!checkbox || checkbox.checked) return;

    event.preventDefault();
    checkbox.focus();
    checkbox.reportValidity();
  });

  document.addEventListener('DOMContentLoaded', updateAll);
  document.addEventListener('shopify:section:load', updateAll);
  document.addEventListener('cart:updated', updateAll);
  setTimeout(updateAll, 500);
})();

